import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import "toastr/build/toastr.min.css";
import { DisplayMessage, GetPickerCss } from "../../../../services/helpers.js";
import DelayedRedirect from "../../../../utils/DelayedRedirect";
import { Transition } from "../../../../utils/ModalHelpers";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import { SketchPicker } from "react-color";
import { SelectTheme } from "../../../../utils/utils.js";
import { ThemeProvider } from "@material-ui/core";
import appFetch from "../../../../api/appFetch.js";
import { DossierStacksUrl, DossierStacksWithIdUrl } from "../../../../constants/apiUrls.js";
import OutletsDropdown from "../../../Common/Dropdowns/OutletsDropdown.js";
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';
import {	getUsageTypeOptions } from "./utils/optionFormatters";

export default class DossierStackCreation extends Component {
  constructor(props) {
    super(props);
    var editedDossierStack = undefined;
    var outletId = 0;
    var editedDossierStackId = 0;
    var id = 0;

    if (
      this.props.location !== undefined &&
      this.props.location.state !== undefined
    ) {
      editedDossierStack = this.props.location.state.editedDossierStack;
      editedDossierStackId = this.props.location.state.dossierStackId;
      id = parseInt(this.props.dossierStackId);
    } else if (this.props !== undefined) {
      outletId = this.props.outletId;
      if (this.props.dossierStackId !== undefined)
        id = parseInt(this.props.dossierStackId);
    }

    this.state = {
      id: id,
      description: "",
      outletId: outletId,
      usageType: "DOSSIERS", 
      isUsageTypeDisabled: false,
      color: "",
      modifiedByName: "",
      modifiedOn: "",
      modifiedByAvatar: "",
      editedDossierStack: editedDossierStack,
      editedDossierStackId: editedDossierStackId,
      loading: this.props.editedDossierStackId !== undefined,
      accessibleMoboOutlets: [],
      requestInProgress: false,
      redirect: null,
      open: true,
      dossierStackWasCreated: false,
      displayColorPicker: false,
      createdByName: "",
      createdOn: "",
    };
  }

  componentDidMount() {
    if (
      this.props.location !== undefined &&
      this.props.location.state !== undefined &&
      this.props.location.state.editedDossierStack !== undefined
    ) {
      this.setStateDossierStackDetails(
        this.props.location.state.editedDossierStack
      );
    } else if (this.state.id !== undefined && this.state.id > 0) {
      this.getDossierStackDetails();
    }
  }

  handleClose = () => {
    this.setState({
      open: false,
      redirect: "/dossierstacks",
      outletId: this.state.outletId,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/^\s+/, ""),
    });
  };

  handleClickColorPicker = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleCloseColorPicker = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChangeColorPicker = (color) => {
    this.setState({
      color: color.hex,
    });
  };

  handleChangeComplete = () => {
    this.setState({
      // requestInProgress: !this.checkIfRequestIsValid(false),
    });
  };

  handleChangeOutlet = (e) => {
    this.setState({
      outletId: parseInt(e.target.value),
    });
  };

  handleChangeUsageType = (e) => {
    this.setState({
      usageType: e.target.value,
    });
  };
  isValidForm = () => {
    const { description, color, outletId } = this.state;

    if (!description || description.trim().length === 0 || description.length > 100) {
      return false;
    }

    if (!color || color.trim().length === 0) {
      return false;
    }

    if (outletId < 0) {
      return false;
    }

    return true;
  }

  isValidForm = () => {
    const { description, color, outletId } = this.state;

    if (!description || description.trim().length === 0 || description.length > 100) {
      return false;
    }

    if (!color || color.trim().length === 0) {
      return false;
    }

    if (outletId < 0) {
      return false;
    }

    return true;
  }

  handleSubmit = () => {
    if (this.state.id === 0) {
      this.saveNewDossierStack()
      return;
    }

    this.saveEditedDossierStack()
  };

  saveNewDossierStack = () => {
    let resources = this.props.resources;

    if (!this.isValidForm()) {
      return;
    }

    this.setState({ requestInProgress: true });

    var json = JSON.stringify({
      outletId: this.state.outletId > 0 ? this.state.outletId : null,
      colorHex: this.state.color.replace("#", ""),
      description: this.state.description,
      usageType: this.state.usageType,
    });

    appFetch({
      url: DossierStacksUrl(),
      method: 'POST',
      body: json,
      onSuccess: () => {
        DisplayMessage(resources["NewDossierStackWasSaved"], "success");
        this.setState({
          dossierStackWasCreated: true,
          redirect: "/dossierstacks",
        });
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  };

  saveEditedDossierStack = () => {
    let resources = this.props.resources;
    if (!this.isValidForm()) {
      return;
    }

    this.setState({ requestInProgress: true });

    var bodyJson = {};
    if (this.state.description !== "")
      bodyJson.description = this.state.description;
    if (this.state.colorHex !== "")
      bodyJson.colorHex = this.state.color.replace("#", "");
    if (this.state.usageType !== null)
      bodyJson.usageType = this.state.usageType;

    var json = JSON.stringify(bodyJson);

    appFetch({
      url: DossierStacksWithIdUrl(this.state.id),
      method: 'PATCH',
      body: json,
      onSuccess: () => {
        DisplayMessage(resources["DossierStackEditedSuccessfully"], "success");
        this.setState({
          dossierStackWasCreated: true,
          redirect: "/dossierstacks",
        });
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  };

  setStateDossierStackDetails = (editedDossierStack) => {
    this.setState({
      id: editedDossierStack.id,
      description: editedDossierStack.description,
      outletId: editedDossierStack.outletId,
      color: "#" + editedDossierStack.colorHex,
      modifiedOn: editedDossierStack.modifiedOn,
      modifiedByName: editedDossierStack.modifiedByName,
      modifiedByAvatar: editedDossierStack.modifiedByAvatar,
      createdByName: editedDossierStack.createdByName,
      createdOn: editedDossierStack.createdOn,
      requestInProgress: false,
      usageType: editedDossierStack.usageType ?? "DOSSIERS",
      isUsageTypeDisabled: editedDossierStack.usageType === "DAILYSCHEDULE",
    });
  };

  getDossierStackDetails = () => {
    const { id } = this.state;

    let url = DossierStacksWithIdUrl(id);

    this.setState({ requestInProgress: true });

    appFetch({
      url: url,
      onSuccess: (data) => {
        if (data.id === id) {
          this.setStateDossierStackDetails(data);
        } else {
          this.setState({ open: false, redirect: "/dossierstacks" });
        }
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }

        this.setState({ open: false, redirect: "/dossierstacks" });
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  };

  renderModifiedByInfo = () => {
    let resources = this.props.resources;
    const { modifiedOn, modifiedByName, modifiedByAvatar, createdByName, createdOn } = this.state;

    var modificateDate = modifiedOn ?? createdOn;
    var useName = modifiedByName ?? createdByName;

    if (this.state.id > 0) {
      return (
        <ModifiedByInfo
          resources={resources}
          modifiedOn={modificateDate}
          modifiedByName={useName}
          modifiedByAvatar={modifiedByAvatar}
          isCreated={createdOn ? true : false}
          className="mt-3"
        />
      );
    }
    return;
  };

  renderForm() {
    const handleSubmit = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit();
    };
    const { description, outletId, usageType, isUsageTypeDisabled } = this.state;
    var resources = this.props.resources;
    const usageTypeOptions = getUsageTypeOptions(resources);

    var helperTextDescription =
      description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";

    const styles = GetPickerCss(this.state.color);

    return (
      <div>
        <Paper elevation={3} className="p-4 mt-3 mb-3">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="d-flex">
              <div className="col-3"></div>
              <OutletsDropdown
                resources={resources}
                outlets={this.props.accessibleMoboOutlets}
                outlet={outletId ?? 0}
                onOutletChange={this.handleChangeOutlet}
                containerClass="col-6 helper-text-red"
                disabled={this.state.id > 0}
              />
              <div className="col-3"></div>
            </Form.Group>
            <Form.Group className="d-flex">
              <div className="col-3"></div>
              <EnhancedDropdownComponent
                value={usageType}
                handleChange={(e) =>
									this.handleChangeUsageType(e)
                }                
                options={usageTypeOptions}
                labelText={resources["Type"]}
                style={{ maxWidth: "800px", width: "100%" }}
                id="usage-type-dropdown"
                addMarginBottom = {false}
              />
              <div className="col-3"></div>
            </Form.Group>
            <Form.Group
              style={{ display: "flex" }}
            >
              <div className="col-3"></div>
              <ThemeProvider theme={SelectTheme}>
                <TextField
                  className={"col-6 " + helperTextDescription}
                  id="dossierStack-description"
                  label={resources["Description"]}
                  helperText={resources["InputOfDescriptionIsMandatory"]}
                  value={description || ""}
                  variant="outlined"
                  name="description"
                  onChange={this.handleChange}
                  onKeyUp={this.handleChangeComplete}
                  inputProps={{ maxLength: 100 }}
                />
              </ThemeProvider>
            </Form.Group>
            <Form.Group style={{ display: "flex" }}>
              <div className="col-md-3"></div>
              <div>
                <div style={{ display: "flex" }}>
                  <div
                    style={styles.swatch}
                    onClick={this.handleClickColorPicker}
                  >
                    <div style={styles.color} id="color-picker" />
                  </div>
                  <span
                    className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1 align-center"
                    style={{ paddingTop: "8px", paddingLeft: "3px" }}
                  >
                    {resources["ColorHex"]}
                    <em className="text-danger">*</em>
                  </span>
                </div>
                {this.state.displayColorPicker ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={this.handleCloseColorPicker}
                    />
                    <SketchPicker
                      color={this.state.color}
                      onChange={this.handleChangeColorPicker}
                      onChangeComplete={this.handleChangeComplete}
                    />
                  </div>
                ) : null}
              </div>
            </Form.Group>
            {this.renderModifiedByInfo()}
          </Form>
        </Paper>
      </div>
    );
  }

  renderMain() {
    const { loading } = this.state;

    if (loading)
      return (
        <div className="centered-loader">
          <CircularProgress />
        </div>
      );

    return (
      <div
        className={"py-4 grey " + (this.state.loading ? "fadeOut" : "fadeIn")}
      >
        {this.renderForm()}
      </div>
    );
  }

  render() {
    const {
      redirect,
      open,
      dossierStackWasCreated,
      outletId,
      id,
      requestInProgress,
    } = this.state;
    const { resources } = this.props;

    const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

    return (
      <div>
        {redirect && (
          <DelayedRedirect
            to={{
              pathname: redirect,
              state: { refreshGrid: dossierStackWasCreated, outletId },
            }}
            delay={250}
          />
        )}
        <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className="position-sticky ">
            <Toolbar>
              <IconButton
                id="close-add-dossierStack"
                edge="start"
                color="inherit"
                onClick={this.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ flex: 1 }}>
                {id !== undefined && id > 0
                  ? resources["EditDossierStackTitle"]
                  : resources["AddNewDossierStackTitle"]}
              </Typography>
              <Button
                id="dossierStack-save"
                color="inherit"
                disabled={isSaveButtonDisabled}
                onClick={this.handleSubmit}
              >
                {resources["Save"]}
              </Button>
            </Toolbar>
          </AppBar>
          <div className="container">{this.renderMain()}</div>
        </Dialog>
      </div>
    );
  }
}
